export const uploadConstants = {
    UPLOAD_PROCESS: 'upload:process',
    UPLOAD_PROCESS_START: 'upload:process:start',
    UPLOAD_PROCESS_STOP: 'upload:process:stop',
    UPLOAD_PROCESS_CLEAR: 'upload:process:clear',
    UPLOAD_PROCESS_FAILURE: 'upload:process:failure',
    UPLOAD_RESPOND: 'upload:respond',
    UPLOAD_PROGRESS: 'upload:progress',
    UPLOAD_DELETE: 'upload:delete',
};
